import { ArrowDownIcon } from 'assets/icons';
import React from 'react';

interface IDropDownButton {
  dropDownArrowColor?: string;
}
export default function DropDownButton({
  dropDownArrowColor = 'text-gray-light',
}: IDropDownButton) {
  return (
    <div className="p-1">
      <ArrowDownIcon className={`w-3 h-3 ${dropDownArrowColor}`} />
    </div>
  );
}
